import { get, set, del, entries } from 'idb-keyval';

export class IndexeddbCoreCacheService {

    hasIndexedDb: boolean = false;
    // 5 minutes in ms
    defaultFreshness: number = 300000;

    constructor() {
        if (!window.indexedDB) {
            console.warn('Indexed DB is unsupported on this browser.');
        } else {
            this.hasIndexedDb = true;
        }

        setInterval(
            () => {
                this.purgeOldRecords();
            }, this.defaultFreshness
        );
    }

    set(key: IDBValidKey, val: any): Promise<void> {
        if (!this.hasIndexedDb) {
            return Promise.reject(new Error('indexeddb not supported'));
        }

        const setValue: any = {};
        setValue.data = val;
        setValue.expiration = +new Date();

        return set(key, setValue);
    }

    // "freshness" defines how recently the data had to have been stored, the default freshness is 15 minutes, 900,000 ms
    async get<T>(key: IDBValidKey, freshness: number = this.defaultFreshness): Promise<T> {
        if (!this.hasIndexedDb) {
            return Promise.reject(new Error('indexeddb not supported'));
        }
        const getValue = await get(key);
        if (getValue && (getValue.expiration + freshness) > +new Date()) {
            return getValue.data;
        }
        this.del(key);
        return null;
    }

    del(key: IDBValidKey): Promise<void> {
        if (!this.hasIndexedDb) {
            return Promise.reject(new Error('indexeddb not supported'));
        }
        return del(key);
    }

    async purgeOldRecords(): Promise<void> {
        const now: number = +new Date();
        for (const [key, value] of await entries()) {
            if (!value.expiration || (value.expiration + this.defaultFreshness) < now) {
                this.del(key);
            }
        }
    }
}
